import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh_cn = {
    common:{
        lostTitle:"温馨提示",
        lostContent:"目前的网路环境存取权限受到限制，我们无法为中国大陆地区提供服务，请您遵守所在国家和地区相关规定访问我们的服务。",
        connect:"链接",
        walletMsgPro:"请切换到 BSC Mainnet 主网访问",
        walletMsgTest:"请切换到 BSC Testnet 测试网访问",
        notice:"MPC服务器维护公告",
        noticeContent1:"各位会员:",
        noticeContent2:"由于服务器要进行电力升级改造，MPC系统将在 2026-05-08 00:00 至 2026-05-08 12:00 期间暂停访问，待升级完成后立即恢复访问，请各位会员知悉！",
        balance:"余额",
        approve:"授权",
        sign:"交易签名",
        confirmByWallet:"请在钱包中确认交易签名",
        language:"语言设置",
        loading:"正在拼命加载中...",
        confirm:"确定",
        cancel:"取消",
        copySuccess:"复制成功",
        max:"最大",
        min:"最少 ",
        amount:"数量",
        all:"全部",
        enterQuantity:"输入数量",
        day:"天",
        noData:"暂无记录",
        notStart:"敬請期待",
        know:"知道了",
        stcBalanceOut:"钱包 STC 余额不足",
        mpcBalanceOut:"钱包 MPC 余额不足",
        xlBalanceOut:"钱包 XL 余额不足",
        mineBalanceOut:"钱包 MINE 余额不足",
        usdtBalanceOut:"钱包 USDT 余额不足",
        test1BalanceOut:"钱包 GTS 余额不足",
        test2BalanceOut:"钱包 APT 余额不足",
        approveStcFail:"授权 STC 失败",
        approveMpcFail:"授权 MPC 失败",
        approveXlFail:"授权 XL 失败",
        approveMineFail:"授权 MINE 失败",
        approveUsdtFail:"授权 USDT 失败",
    },
    home:{
        pledge:"质押",
        node:"节点",
        exchange:"兑换",
        my:"我的"
    },
    pledge:{
        mode1:"STC+MPC联和挖矿",
        mode2:"MPC挖矿",
        mode3:"合并订单",
        ruleLabel:"规则",
        mode1Msg:"100枚STC+100USDT等值MPC起投；购买MPC转换成金本位质押，获得总投入金额等值的2倍权益值，金本位1%加速释放收益，收益提现按照MPC实时价格转换成MPC，100枚STC质押数量每天增量1%进行质押；",
        mode2Msg:"会员无星币可直接购买200USDT等值MPC质押，获得总投入金额等值的2倍权益值，金本位1%加速释放收益，收益提现按照MPC实时价格转换成MPC；",
        mpcPrice:"MPC当前价格",
        myOrder:"我的订单",
        time:"质押时间",
        amount:"质押数量",
        value:"质押价值",
        profit:"收益权",
        outOrderLimit:"每个账户最多持有100笔",
        pledgeSuccess:"质押成功",
        pledgeFail:"质押失败"
    },
    node:{
        title:"节点升级",
        msg:"成为社区节点、超级节点、创世节点不仅可以获得双倍的收益权，还可以获得更快的加速释放奖励和获得额外的节点分红奖励；",
        node3:"社区节点",
        node4:"超级节点",
        node5:"创世节点",
        node6:"元节点",
        nodeProfit3:"获得新增账户20%级差加速释放奖励",
        nodeProfit4:"获得新增账户25%级差加速释放奖励",
        nodeProfit5:"获得新增账户30%级差加速释放奖励",
        nodeProfit6:"获得新增账户40%级差加速释放奖励",
        nodeTask3:"销毁一枚令牌(1000枚MPC)；",
        nodeTask4:"销毁一枚令牌(5000枚MPC)；",
        nodeTask5:"销毁一枚令牌(10000枚MPC)；",
        nodeTask6:"销毁一枚令牌(50000枚MPC)；",
        task:"任务",
        task1:"任务1",
        task2:"任务2",
        inviteTask:"直推10个有效会员；",
        finish:"已完成",
        execute:"执行",
        nodeBonus:"节点分红",
        takeAmt:"已领取",
        waitAmt:"待领取",
        takeBonus:"领取分红",
        needPay:"需支付",
        plsFinishTask1:"请先完成任务1！",
        upgradeSuccess:"升级成功",
        upgradeFail:"升级失败",
        noBonus:"没有可领取的分红 ",
        takeSuccess:"领取成功",
        takeFail:"领取失败",
        node0SoldOut:"社区节点已售罄",
        node1SoldOut:"超级节点已售罄",
        node2SoldOut:"创世节点已售罄",
        node3SoldOut:"元节点已售罄",
        orderList:"节点订单",
        nodeOrder3:"社区节点订单",
        nodeOrder4:"超级节点订单",
        nodeOrder5:"创世节点订单",
        nodeOrder6:"元节点订单",
    },
    exchange:{
        title:"兑换",
        notOpen:"暂未开放",
        plsInputAmt:"请输入兑换数量",
        exchangeSuccess:"兑换成功",
        exchangeFail:"兑换失败",
        price:"价格",
        fee:"手续费",
        myLogList:"我的兑换",
        myTotalUsdt:"累计兑换",
        usdtAmt:"USDT数量",
        time:"时间",
        mpcAmt:"MPC数量",
    },
    my:{
        myProfit:"我的收益权",
        pledgeTotal:"剩余质押收益权",
        pledgeWait:"可释放质押收益权",
        nodeTotal:"剩余节点收益权",
        nodeWait:"可释放节点收益权",
        exchange:"兑换",
        myInviteUrl:"我的邀请链接",
        bindCode:"绑定的邀请码",
        notBind:"未绑定",
        myTeam:"我的团队",
        address:"地址",
        hasActive:"已激活",
        notActive:"未激活",
        time:"时间",
        buyVal:"累计质押",
        noProfit:"暂无可兑换的收益",
        exchangeSuccess:"兑换成功",
        exchangeFail:"兑换失败",
        aboutUs:"关于我们",
        foundation:"基金会证书",
    },
    bind:{
        title:"绑定邀请码",
        holder:"输入邀请码",
        confirm:"确认绑定",
        errorCode:"邀请码错误",
        cannotBeSelf:"不能绑定自己的邀请码",
        cannotBeChild:"禁止循环绑定",
        bindSuccess:"绑定成功",
        bindFail:"绑定失败"
    },
    ...cnLocale
}
export default zh_cn
